import { ResourcesService } from '@mitsubishi/core';

export interface ProjectStatisticsCounts {
  quoteDraftCount: number;
  offerDraftCount: number;
  offerFinalCount: number;
  orderDraftCount: number;
  orderFinalCount: number;
  orderErrorCount: number;
}

export const INACTIVE_ICON_COLOR = 'var(--apm-light-gray2)';

const ORDER_STATUS_RESOURCE_IDS = {
  error: 448758,
  draft: 448757,
  final: 448761,
} as const;

const ORDER_TOOLTIP_FALLBACK_RESOURCE_ID = 444925;

export function getQuoteColor(counts: ProjectStatisticsCounts): string {
  return counts.quoteDraftCount > 0 ? 'var(--apm-selection-quote)' : INACTIVE_ICON_COLOR;
}

export function getOfferColor(counts: ProjectStatisticsCounts): string {
  return counts.offerDraftCount + counts.offerFinalCount > 0 ? 'var(--apm-selection-offer)' : INACTIVE_ICON_COLOR;
}

export function getOrderColor(counts: ProjectStatisticsCounts): string {
  if (counts.orderErrorCount > 0) return 'var(--apm-selection-error)';
  if (counts.orderDraftCount > 0) return 'var(--apm-selection-order-draft)';
  if (counts.orderFinalCount > 0) return 'var(--apm-selection-order)';
  return INACTIVE_ICON_COLOR;
}

export function getOrderTooltip(counts: ProjectStatisticsCounts, resourcesService: ResourcesService): string {
  const states = [
    { count: counts.orderErrorCount, resourceId: ORDER_STATUS_RESOURCE_IDS.error },
    { count: counts.orderDraftCount, resourceId: ORDER_STATUS_RESOURCE_IDS.draft },
    { count: counts.orderFinalCount, resourceId: ORDER_STATUS_RESOURCE_IDS.final },
  ];
  const tooltip = states
    .filter(state => state.count > 0)
    .map(state => `${state.count} ${resourcesService.getTextResource(state.resourceId)}`)
    .join('\n');
  return tooltip || resourcesService.getTextResource(ORDER_TOOLTIP_FALLBACK_RESOURCE_ID);
}
